module.exports = __webpack_public_path__ + "img/send.79a8fc5d.svg";